import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';
import { AgentsData } from '~/sections/companies/profile/connections/types';

type IndexParams = {
  license: string;
  agent_type: string;
  limit?: number;
  period: Period;
  page?: number;
  sort_field?: string;
  order?: Order;
};

type IndexResponse = {
  data: AgentsData;
};

export const index = async (allParams: IndexParams) => {
  const { license, sort_field, order, ...params } = allParams;
  return apiClient.get<IndexResponse>(
    `/companies/${license}/realtors?sort[field]=${sort_field}&sort[order]=${order}`,
    { params, timeout: 25000 } // temporary fix for heavy Connections page queries
  );
};
